export const selectUserLevels = (state) => state.levels.levels;
export const selectSpinner = (state) => state.levels.spinner;
